import { render, staticRenderFns } from "./OrderGDItemEdit.vue?vue&type=template&id=2f23f626"
import script from "./OrderGDItemEdit.vue?vue&type=script&lang=js"
export * from "./OrderGDItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderGDItemEdit.vue?vue&type=style&index=0&id=2f23f626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports